var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEduBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 359,
    viewBox: "0 0 440 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_404)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_220_404",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 442,
    height: 359
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440.02 0.395752H-0.0197754V359H440.02V0.395752Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_220_404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.701 155.563C354.701 155.563 347.249 165.373 338.5 186.032C338.5 186.032 349.693 194.908 325.871 143.129L320.218 144.747C320.218 144.747 322.125 178.478 331.477 195.519C340.031 211.109 353.211 194.236 356.682 180.869C360.146 167.494 354.708 155.563 354.708 155.563H354.701Z",
    fill: "#804EC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.687 32.7773H297.74C301.755 32.7773 305.018 36.0403 305.018 40.0553V309.201C305.018 313.216 301.755 316.479 297.74 316.479H144.687C140.672 316.479 137.409 313.216 137.409 309.201V40.0553C137.409 36.0403 140.672 32.7773 144.687 32.7773Z",
    fill: "#4376D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.362 42.0195H151.066C148.073 42.0195 145.648 44.4448 145.648 47.4378V273.889C145.648 276.881 148.073 279.307 151.066 279.307H291.362C294.355 279.307 296.78 276.881 296.78 273.889V47.4378C296.78 44.4448 294.355 42.0195 291.362 42.0195Z",
    fill: "#C1DAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.195 47.4379H190.238C187.243 47.4379 184.82 45.0139 184.82 42.0198C184.82 39.0254 187.243 36.6016 190.238 36.6016H252.195C255.189 36.6016 257.613 39.0254 257.613 42.0198C257.613 45.0139 255.189 47.4379 252.195 47.4379Z",
    fill: "#0077D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.309 330.797H66.5112V354.477H203.309V330.797Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.04 331.019C168.04 331.019 167.772 346.911 156.016 354.477H66.5112V330.797L168.04 331.019Z",
    fill: "#EDECEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5162 353.065V332.211C66.5162 331.432 67.1682 330.794 67.9672 330.794H205.067C205.866 330.794 206.517 330.163 206.517 329.378V327.706C206.517 326.927 205.866 326.289 205.067 326.289H62.8912C62.0922 326.289 61.4412 326.92 61.4412 327.706V357.55C61.4412 358.329 62.0922 358.966 62.8912 358.966H205.067C205.866 358.966 206.517 358.335 206.517 357.55V355.878C206.517 355.099 205.866 354.461 205.067 354.461H67.9672C67.1682 354.461 66.5162 353.83 66.5162 353.045V353.065Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.903 265.442H60.1052V289.122H196.903V265.442Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.726 265.663C156.726 265.663 156.471 281.555 145.286 289.122H60.1052V265.442L156.726 265.663Z",
    fill: "#EDECEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1052 287.705V266.852C60.1052 266.073 60.7562 265.435 61.5552 265.435H198.656C199.455 265.435 200.106 264.804 200.106 264.018V262.346C200.106 261.568 199.455 260.93 198.656 260.93H56.4732C55.6742 260.93 55.0232 261.561 55.0232 262.346V292.19C55.0232 292.969 55.6742 293.607 56.4732 293.607H198.656C199.455 293.607 200.106 292.976 200.106 292.19V290.519C200.106 289.74 199.455 289.102 198.656 289.102H61.5552C60.7562 289.102 60.1052 288.471 60.1052 287.685V287.705Z",
    fill: "#2A4591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.403 298.11H46.6052V321.79H183.403V298.11Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.134 298.331C148.134 298.331 147.866 314.223 136.109 321.79H46.6052V298.11L148.134 298.331Z",
    fill: "#EDECEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6102 320.381V299.527C46.6102 298.749 47.2612 298.111 48.0602 298.111H185.168C185.967 298.111 186.618 297.48 186.618 296.694V295.022C186.618 294.243 185.967 293.606 185.168 293.606H42.9852C42.1862 293.606 41.5342 294.237 41.5342 295.022V324.866C41.5342 325.645 42.1862 326.283 42.9852 326.283H185.168C185.967 326.283 186.618 325.652 186.618 324.866V323.194C186.618 322.415 185.967 321.778 185.168 321.778H48.0602C47.2612 321.778 46.6102 321.147 46.6102 320.361V320.381Z",
    fill: "#5E1A94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4761 293.617L186.614 296.699V294.819C186.614 294.154 186.077 293.617 185.412 293.617H56.4761Z",
    fill: "#2B0A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.167 326.297L61.4412 329.97V327.606C61.4412 326.881 62.0252 326.297 62.7502 326.297H185.167Z",
    fill: "#2B0A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.207 71.5469H162.437V75.1989H279.207V71.5469Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.207 81.5669H162.437V85.2189H279.207V81.5669Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.602 92.7419H162.831V96.3949H279.602V92.7419Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.21 174.387H223.484V176.831H279.21V174.387Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.21 187.293H223.484V189.737H279.21V187.293Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.21 200.195H223.484V202.639H279.21V200.195Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.21 213.102H223.484V215.546H279.21V213.102Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.028 167.676H162.437V222.268H217.028V167.676Z",
    fill: "#0077D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.803 310.667C227.715 310.667 233.318 305.064 233.318 298.152C233.318 291.24 227.715 285.637 220.803 285.637C213.891 285.637 208.288 291.24 208.288 298.152C208.288 305.064 213.891 310.667 220.803 310.667Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.324 301.707C213.518 301.707 210.852 301.11 208.448 300.036C209.355 306.051 214.538 310.671 220.809 310.671C227.718 310.671 233.324 305.071 233.324 298.156C233.324 296.424 232.975 294.779 232.337 293.281C228.839 298.371 222.971 301.707 216.331 301.707H216.324Z",
    fill: "#EDECEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.263 358.899H228.554V339.703H292.263V358.899ZM228.943 358.509H291.874V340.093H228.943V358.509Z",
    fill: "#393838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.449 124.745L358.062 124.692L359.713 141.53L371.382 141.577L371.449 124.745Z",
    fill: "#E19674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.838 153.309C361.974 155.847 373.536 153.638 373.536 153.638C370.817 144.004 371.193 133.328 371.193 133.328L359.651 140.519C360.457 152.295 356.831 153.309 356.831 153.309H356.838Z",
    fill: "#E19674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.609 124.732L358.068 124.692C358.068 124.692 355.98 131.432 357.114 136.555C357.732 139.328 359.082 141.577 362.385 141.973C366.702 142.161 369.488 138.898 370.113 136.555C371.469 131.486 369.609 124.739 369.609 124.739V124.732Z",
    fill: "#E19674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.719 230.5L385.681 231.272C386.406 230.654 387.473 219.972 386.285 203.207C385.096 186.442 381.605 156.901 373.938 150.804C368.291 146.312 360.443 150.838 360.443 150.838C360.443 150.838 354.669 153.275 352.345 159.922C349.787 167.247 346.269 195.305 345.631 208.39C345.276 215.601 344.906 226.391 345.712 230.5H345.719Z",
    fill: "#6E42A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.787 349.781L274.739 352.306C274.739 352.306 260.189 355.804 260.015 358.711H286.24C286.24 358.711 287.818 358.342 287.985 356.596C288.153 354.85 287.005 349.788 287.005 349.788H277.773L277.787 349.781Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.112 349.781L299.748 351.064C299.748 351.064 295.183 353.575 295.183 358.704H308.967C308.967 358.704 310.545 358.335 310.712 356.589C310.88 354.844 311.33 349.781 311.33 349.781H302.098H302.112Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.722 230.504C322.773 232.411 292.507 236.909 292.507 236.909C292.507 236.909 267.739 240.038 269.249 270.211C270.511 295.462 276.192 349.779 276.192 349.779H287.021C287.021 349.779 299.127 298.819 291.338 264.41C291.338 264.41 335.785 274.904 367.986 270.211C389.001 260.65 385.697 231.276 385.697 231.276L345.735 230.504H345.722Z",
    fill: "#2A4591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.627 262.973C301.627 262.973 299.801 332.04 300.586 349.778H311.859C311.859 349.778 327.469 281.222 322.648 262.973H301.627Z",
    fill: "#2A4591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.825 210.324L345.265 219.227V224.672C345.265 224.672 362.936 220.51 369.825 210.324Z",
    fill: "#2B0A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.667 157.645C368.486 153.08 364.625 153.657 363.732 153.812C355.467 155.517 354.198 161.795 353.708 167.112C352.399 181.306 356.555 204.462 356.555 204.462C334.271 205.14 307.402 212.204 307.402 212.204L307.757 217.877C333.956 221.395 361.127 221.764 369.829 210.33C376.193 201.971 372.575 168.824 369.674 157.645H369.667Z",
    fill: "#804EC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.533 266.504L301.284 276.797L322.501 289.191C323.32 281.678 323.743 274.776 323.488 269.431C314.941 268.706 307.246 267.531 301.533 266.504Z",
    fill: "#4376D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.767 270.215H318.687V358.713H385.767V270.215Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.054 359H318.39V269.918H386.054V359ZM318.974 358.416H385.463V270.509H318.974V358.416Z",
    fill: "#393838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.136 270.211C326.136 270.211 365.635 277.442 377.492 270.211H326.136Z",
    fill: "#4376D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.062 124.691C358.062 124.691 361.808 128.753 365.185 128.881C365.185 128.881 359.693 146.029 361.654 150.285C361.654 150.285 362.694 149.741 363.91 149.439C363.91 149.439 369.583 155.677 373.934 153.709C378.284 151.742 374.149 146.096 373.934 143.142C372.953 129.505 375.921 124.423 373.35 122.724C370.771 121.032 358.122 123.349 358.062 124.698V124.691Z",
    fill: "#2B0A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.714 129.216C364.714 129.216 366.534 127.685 367.897 129.324C369.025 130.673 368.045 134.057 364.097 133.748C364.097 133.748 363.244 131.539 364.714 129.216Z",
    fill: "#E19674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.394 28.0078V71.3339H363.245L374.659 84.5329V71.3339V28.0078H280.394Z",
    fill: "#B22E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.606 38.8984H289.96V39.6772H362.606V38.8984Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.606 48.2849H289.96V49.0639H362.606V48.2849Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.606 57.6719H289.96V58.4509H362.606V57.6719Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.818 113.949V157.268H104.96L93.5461 170.475V157.268V113.949H187.818Z",
    fill: "#287C74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.596 125.617H178.241V124.838H105.596V125.617Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.596 135.008H178.241V134.229H105.596V135.008Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.596 144.391H178.241V143.612H105.596V144.391Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.027 358.508H50.0581V358.897H230.027V358.508Z",
    fill: "#393838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.595 358.508H308.972V358.897H410.595V358.508Z",
    fill: "#393838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.501 208.748C204.118 205.011 207.264 195.808 203.528 188.191C199.791 180.574 190.588 177.428 182.971 181.164C175.354 184.901 172.208 194.105 175.944 201.722C179.681 209.338 188.885 212.484 196.501 208.748Z",
    fill: "#B22E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.633 195.374L184.749 188.512V202.229L196.633 195.374Z",
    fill: "#FEFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.208 143.317C325.208 143.317 325.175 137.811 323.98 135.73C322.784 133.656 320.341 131.205 320.173 131.406C320.005 131.608 321.146 134.058 321.462 134.75C321.462 134.75 319.219 136.301 318.615 137.724C318.011 139.148 319.347 143.082 321.193 144.458L325.208 143.31V143.317Z",
    fill: "#E19674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4021 271.727V283.966L76.8801 280.321L82.3521 283.966V271.727H71.4021Z",
    fill: "#B22E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.038 336.516V348.755L165.517 345.11L170.989 348.755V336.516H160.038Z",
    fill: "#B22E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.948 191.61L273.823 201.775L299.149 216.472L306.548 207.408L283.948 191.61Z",
    fill: "#B22E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.441 212.873C306.864 212.813 306.307 212.813 305.783 212.853L305.769 212.819L302.533 212.336L301.459 213.652L302.07 213.994C300.707 214.733 299.915 215.545 299.915 215.545C298.686 214.928 292.952 212.873 292.952 212.873C292.952 212.873 298.277 217.66 299.646 217.727C301.016 217.795 307.717 217.143 307.717 217.143L307.448 212.873H307.441Z",
    fill: "#E19674"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 359,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEduBanner);
export default __webpack_public_path__ + "static/media/edu_banner.feb386f59d8644bd9b2afbc253048ad2.svg";
export { ForwardRef as ReactComponent };